/**
 * Check if search string occurs in target string
 * @param search
 * @param target
 */
export const searchFilter = (search: string, target: string) => target?.toLowerCase().includes(search.toLowerCase());
